import React from 'react';
import CRUD_Gastos from '../Firebase/CRUDS/CRUD_Gastos';


const Gastos = () =>{
    return(
        <div>
            <div >
             
            <div id="listas">  
               
            </div>  
            <CRUD_Gastos/>
            </div>
        </div>
    )
}

export default Gastos;